import request from '@/utils/request';


/**
 * 图片上传
 * @param { file: 文件对象 } data 
 */
export function upload(data) {
  return request({
    url: '/upload',
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  });
}

export function getWxJson(data) {
  return request({
    url: '/account/get-signature',
    method: 'post',
    data
  });
}

export function getareafindall(data) {
  return request({
    url: '/area/find-all',
    method: 'GET',
    data
  });
}

export function getlatandlngbyaddress(data) {
  return request({
    url: '/get-lat-and-lng-by-address',
    method: 'post',
    data
  })
}